module.exports = __webpack_public_path__ + "img/banner.eb2ab40d.png";